import TENANT from './tenant';

export default {
  feedback_gestor: {
    key: '651daf9b13c7840027016786',
    action: '661eb38a49ce7e0020eda274',
    canEnable: () => {
      const { REACT_APP_COOP_NAME, NODE_ENV } = process.env;
      return TENANT.NOVACOOP === REACT_APP_COOP_NAME && NODE_ENV !== 'development';
    },
  },
};
